/**
 * Seasonal monthly offers for the sitewide AnnouncementBar.
 * Keyed by 0-indexed month (0 = Jan).
 */
export const MONTHLY_OFFERS = {
  0: {
    label: "January complimentary care assessment",
    cta: "Book my free assessment",
    tagline: "New year, new peace of mind — complimentary in-home care assessment.",
  },
  1: {
    label: "February: $100 off first 10 hours of care",
    cta: "Claim my February offer",
    tagline: "Compassionate care for the heart-month — $100 off your first care package.",
  },
  2: {
    label: "March respite care special",
    cta: "Book respite care",
    tagline: "Give family caregivers a break — reduced-rate respite care all March.",
  },
  3: {
    label: "April: Alzheimer's & dementia consult",
    cta: "Book a free consult",
    tagline: "Complimentary 30-min dementia-care planning session with a specialist.",
  },
  4: {
    label: "May: Mother's Day Gift of Care",
    cta: "Gift the Gift of Care",
    tagline: "Give mom the gift that matters most — gift-cards of care available.",
  },
  5: {
    label: "June hurricane-ready home visit",
    cta: "Schedule prep visit",
    tagline: "Free in-home hurricane-ready assessment with any June care package.",
  },
  6: {
    label: "July: 24-hour live-in care special",
    cta: "Learn about live-in care",
    tagline: "Reduced-rate July start-up on live-in care — concierge white-glove.",
  },
  7: {
    label: "August back-home transition care",
    cta: "Book transition care",
    tagline: "Snowbird returning? Discounted August transition care packages.",
  },
  8: {
    label: "September: free medication review",
    cta: "Schedule med review",
    tagline: "Complimentary medication reminder-plan review with any new client.",
  },
  9: {
    label: "October fall-prevention home audit",
    cta: "Book fall-prevention audit",
    tagline: "Free in-home fall-prevention audit for every October consultation.",
  },
  10: {
    label: "November: Season concierge waitlist",
    cta: "Secure season care",
    tagline: "Season is here. Reserve your preferred caregiver before Thanksgiving.",
  },
  11: {
    label: "December holiday respite care",
    cta: "Book holiday respite",
    tagline: "Enjoy the holidays with family — reserve holiday respite care now.",
  },
};

export function getCurrentOffer() {
  return MONTHLY_OFFERS[new Date().getMonth()] || MONTHLY_OFFERS[0];
}
